<template>
  <div>
    <b-card no-body class="mb-2">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block href="#" v-b-toggle.accordion-1 variant="outline-primary">
          <h4 class="text-center">Кибернетический физкультурно-спортивный конструктор</h4>
          <h5 class="text-center">(тренировки на выносливость)</h5>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text class="alert alert-warning">
            Выносливость является важнейшим физическим качеством, отражающим общий уровень работоспособности
            человека и проявляющимся как в спортивной, так и в повседневной жизни. Выносливость нужно развивать
            не только для того, чтобы уметь переносить длительные физические нагрузки, но также, чтобы успешно
            преодолевать психоэмоциональные потрясения и разнообразные стрессы. То есть хорошая выносливость –
            это залог крепкого здоровья, а значит и жизненного долголетия. Являясь комплексной функциональной
            характеристикой человеческого организма, выносливость интегрирует в себе большое число процессов,
            происходящих на различных уровнях: от клеточного до органного. При этом ведущая роль в реализации
            выносливости принадлежит факторам энергетического обмена, вегетативной регуляции и газотранспортной
            функции. Состояние выносливости во многом зависит от календарного возраста и наследственности
            человека. Тем не менее существуют эффективные программы и методы развития выносливости. Это особые
            типы тренировок, направленные на повышение качества работы систем энергообеспечения мышечной
            деятельности. Естественно, что неподготовленному человеку большие физические нагрузки не выдержать,
            поэтому используются разнообразные методические подходы к построению подобных тренировочных занятий.
            Общим для них является одно – все они должны быть разработаны с учётом индивидуальных особенностей
            конкретного пользователя. Именно в этом заложен секрет успешных тренировок на выносливость.
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
    <template v-if="selectedItem.id">
      <NewDiagnostics @showAll="showAll" v-bind:authorizationToken="authorizationToken"
                      v-bind:item="selectedItem"/>
    </template>
    <template v-else>
      <NewClient @create="createNewClient"/>
      <b-table v-if="items.length > 0" striped small outlined responsive stacked="sm"
               primary-key="id"
               :items="items"
               :fields="fields">
        <template v-slot:cell(show_details)="row">
          <b-button size="sm" variant="danger" class="mx-1" @click="newDiagnostics(row.item)">
            Диагностика
          </b-button>
        </template>
      </b-table>
      <div v-else-if="isBusy" class="text-center text-danger my-2">
        <b-spinner class="align-middle"></b-spinner>
      </div>
    </template>
  </div>
</template>

<script>
import NewClient from './NewClient.vue';
import NewDiagnostics from './NewDiagnostics.vue';
import axios from 'axios';

export default {
  props: {
    authorizationToken: {
      type: String,
      default: '',
    },
    clientLogin: {
      type: String,
      default: '',
    }
  },
  components: {
    NewClient,
    NewDiagnostics
  },
  created: function () {
    axios.defaults.baseURL = 'https://l01s75qla5.execute-api.us-east-1.amazonaws.com/prod';
    axios.defaults.headers.common['Authorization'] = this.authorizationToken;
    this.doClient('');
  },
  data() {
    return {
      isBusy: true,
      fields: [{
        key: 'clientName',
        label: 'Имя',
        class: 'text-left'
      }, {
        key: 'show_details',
        label: 'Действие',
        class: 'text-right'
      }],
      items: [],
      selectedItem: {
        id: this.clientLogin
      }
    }
  },
  methods: {
    doClient(c) {
      this.isBusy = true;
      let vm = this;
      axios.post('/action', {
        clientName: c
      }).then(function (response) {
        vm.isBusy = false;
        vm.items.splice(0);
        response.data.forEach(function (item) {
          vm.items.push({
            site: 'www.cyberconstructor.ru',
            id: item.clientLogin,
            clientName: item.clientName,
            _showDetails: false,
          });
        });
      }).catch(function () {
        //  ignore
      });
    },
    createNewClient(c) {
      if (c) {
        this.doClient(c);
      }
    },
    newDiagnostics(item) {
      this.selectedItem = item;
    },
    showAll() {
      this.selectedItem = {};
    }
  }
}
</script>

<style>
table.b-table[aria-busy='true'] {
  opacity: 0.6;
}
</style>